import { useContext } from 'react'
import { ModalContext } from 'contexts/ModalContext'

// ICONS
import { MdClose } from 'react-icons/md'
import { BsExclamationTriangle } from 'react-icons/bs'

export default function ConfirmCodiBecariModal() {
  const { isModalOpen, closeModal, getModalData } = useContext(ModalContext)
  const { onConfirm } = getModalData || {}

  const handleConfirm = () => {
    closeModal()
    window.onscroll = function () {}
    if (typeof onConfirm === 'function') {
      onConfirm()
    }
  }

  return (
    isModalOpen && (
      <>
        {/* Overlay */}
        <div
          className="w-screen h-screen fixed bg-black bg-opacity-75 top-0 left-0 z-50 flex justify-center items-center"
          onClick={() => {
            closeModal()
            window.onscroll = function () {}
          }}
        />

        {/* Modal */}
        <div className="w-1/2 m-auto justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative w-full my-6 mx-auto max-w-6xl">
            <div className="w-full border-2 border-yellow-500 rounded-md shadow-lg relative flex flex-col bg-white outline-none focus:outline-none divide-y divide-dashed divide-yellow-200">
              {/* Header */}
              <div className="flex items-center justify-between p-5">
                <h3 className="text-2xl font-semibold">
                  <b>Confirmar Canvi</b>
                </h3>
                <button
                  className="transition duration-300 border-yellow-500 bg-yellow-400 text-white hover:border-yellow-300 hover:bg-yellow-200 hover:text-yellow-700 font-ms-semi py-1 px-1 border-2 rounded flex justify-center items-center"
                  type="button"
                  onClick={() => {
                    closeModal()
                    window.onscroll = function () {}
                  }}
                >
                  <MdClose size={25} title="Tancar" />
                </button>
              </div>

              {/* Body */}
              <div className="w-full flex flex-col justify-center items-center px-6 py-12">
                <p className="text-lg font-bold text-yellow-700 text-center whitespace-pre-wrap">
                  ⚠️ Estàs segur que vols canviar el Codi Becari d’Inicialització?
                  {"\n"}Aquest canvi modificarà el número de becari de TOTS els alumnes associats a aquesta escola i no es podrà desfer.
                </p>
              </div>

              {/* Footer */}
              <div className="grid grid-cols-2 p-4 border-t border-solid border-slate-200 rounded-b">
                <div className="col-span-1 flex justify-start items-center text-center">
                  <div
                    className="inline-flex rounded p-2 bg-yellow-500 items-center text-yellow-100 leading-none"
                    role="alert"
                    title="Atenció"
                  >
                    <span className="flex rounded bg-yellow-600 uppercase px-2 py-1 text-xs font-bold mr-3">
                      <BsExclamationTriangle size={25} />
                    </span>
                    <span className="font-semibold mr-2 text-left flex-auto">
                      Aquesta acció no es pot desfer!
                    </span>
                  </div>
                </div>

                <div className="col-span-1 flex justify-end items-center">
                  <button
                    className="transition duration-300 border-yellow-500 bg-yellow-400 text-white hover:border-yellow-300 hover:bg-yellow-200 hover:text-yellow-700 font-ms-semi py-2 px-6 border-2 rounded flex justify-center items-center"
                    type="button"
                    onClick={() => handleConfirm()}
                  >
                    Confirmar Canvi
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  )
}
